export const CHARTS_DATA = 'CHARTS_DATA';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ChartBox/ChartBoxConstants.js